import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
} from 'react-intl';
import { IOrder, IPromoDetail } from '../../../models/talend';

interface IAutoShip {
    promotionName: string;
    description: string;
    orderNumber: number;
    commitmentQuantity: number;
    orderedQuantity: number;
    receivedQuantity: number;
    remainingQuantity: number;
    applicableFor: string;
    nextReleaseDate?: Date;
    nextReleaseCount: number;
    releaseEarly: boolean;
    unitsPerOrder: number;
}

const getDays = (a: Date, b: Date): number => {
    const diff = Math.abs(a.getTime() - b.getTime());

    return Math.ceil(diff / (1000 * 3600 * 24));
};

const getAutoShip = (promoDetail: IPromoDetail): IAutoShip => {
    const orders: IOrder[] = promoDetail.orders;

    const curOrder = orders.find((order) => {
        return (
            order.orderOnPromoHold.toLocaleLowerCase() === 'h' &&
            new Date(order.requestDate) > new Date()
        );
    });

    const nextReleaseDate = curOrder
        ? new Date(curOrder.requestDate)
        : undefined;
    const nextReleaseCount = curOrder
        ? curOrder.items.reduce(
              (sum, current) => sum + current.orderedQuantity,
              0
          )
        : 0;

    const autoShip: IAutoShip = {
        promotionName: promoDetail.promotionName,
        description: promoDetail.description,
        orderNumber: curOrder ? curOrder.orderNumber : 0,
        commitmentQuantity: promoDetail.commitmentQuantity,
        orderedQuantity: promoDetail.orderedQuantity,
        remainingQuantity: promoDetail.remainingQuantity,
        receivedQuantity:
            promoDetail.receivedQuantity - promoDetail.returnedQuantity,
        applicableFor: promoDetail ? promoDetail.products.join(',') : '',
        nextReleaseDate: nextReleaseDate,
        nextReleaseCount: nextReleaseCount,
        releaseEarly:
            nextReleaseDate && nextReleaseCount > 0
                ? getDays(nextReleaseDate, new Date()) < 30
                : false,
        unitsPerOrder:
            orders.length > 0
                ? promoDetail.commitmentQuantity / orders.length
                : 0,
    };

    return autoShip;
};

interface IAutoShipProps {
    promoDetail: IPromoDetail;
    onRelease?: (
        event: React.MouseEvent<HTMLElement>,
        orderNumber: number
    ) => void;
}

//export const AutoShip = ({ promoDetail, onRelease }: IAutoShipProps) => {
export const AutoShip = ({ promoDetail, onRelease }: IAutoShipProps) => {
    const autoShip = getAutoShip(promoDetail);
    // const dateOpts = {
    //   weekday: 'long',
    //   year: 'numeric',
    //   month: 'long',
    //   day: 'numeric'
    // };

    // let hoverUsed =
    //   intl.formatMessage({ id: 'Autoships_Used' }) +
    //   ': ' +
    //   autoShip.receivedQuantity;
    // let hoverRemaining =
    //   intl.formatMessage({ id: 'Autoships_Available' }) +
    //   ': ' +
    //   autoShip.remainingQuantity;
    // let hoverNextRelease = autoShip.nextReleaseDate
    //   ? intl.formatMessage({ id: 'Autoships_Will_Be_Released_On' }) +
    //     ': ' +
    //     autoShip.nextReleaseDate.toLocaleDateString('en-us', dateOpts)
    //   : '';

    return (
        <>
            <div className="panel panel-primary">
                <div className="panel-heading">
                    <h3 style={{ margin: 0, border: 'none' }}>
                        {autoShip.promotionName}
                    </h3>
                </div>
                <div className="panel-body">
                    {autoShip.orderNumber > 0 && (
                        <div>
                            <strong>
                                <FormattedMessage id="Order_Number_2" />:
                            </strong>
                            <span> {autoShip.orderNumber}</span>
                        </div>
                    )}
                    <div>
                        <strong>
                            <FormattedMessage id="Applicable_For" />:
                        </strong>
                        <span> {autoShip.description}</span>
                    </div>
                    {/* <div className="progress">
            <div
              className="progress-bar progress-bar-success"
              id="bill-cert-prog-used"
              title={hoverUsed}
              style={{
                width: `${(autoShip.receivedQuantity /
                  autoShip.orderedQuantity) *
                  100}%`
              }}
            />
            <div
              className="progress-bar progress-bar"
              id="bill-cert-prog-available"
              title={hoverRemaining}
              style={{
                width: `${(autoShip.remainingQuantity /
                  autoShip.orderedQuantity) *
                  100}%`
              }}
            />
            <div
              className="progress-bar progress-bar-info"
              id="bill-cert-prog-available"
              title={hoverNextRelease}
              style={{
                width: `${(autoShip.nextReleaseCount /
                  autoShip.orderedQuantity) *
                  100}%`
              }}
            />
          </div> */}
                    <div>
                        <strong>
                            <FormattedMessage id="Total_Units" />:
                        </strong>
                        <span> {autoShip.commitmentQuantity}</span>
                    </div>
                    <div>
                        <strong>
                            <FormattedMessage id="Units_Shipped" />:
                        </strong>
                        <span> {autoShip.receivedQuantity}</span>
                    </div>
                    <div>
                        <strong>
                            <FormattedMessage id="Units_per_Order" />:
                        </strong>
                        <span> {autoShip.unitsPerOrder}</span>
                    </div>
                </div>
                <div className="panel-footer">
                    <div className="row">
                        <div className="col-md-10" />
                        <div className="col-md-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={(e) =>
                                    onRelease &&
                                    onRelease(e, autoShip.orderNumber)
                                }
                                disabled={!autoShip.releaseEarly}
                            >
                                <FormattedMessage id="Release_Early" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AutoShip;
